module.exports = "/assets/images/86ab0939411211063de03b5ff2093a14.jpg";